module.exports = __webpack_public_path__ + "img/fish-bones.77815b4f.svg";